
import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';
import HeaderFour from '../common/header/HeaderFour';

const PrivacyPolicy = () => (
    <>
        <SEO title="Política de Privacidad" />
        <ColorSwitcher />
        <main className="main-wrapper">
            <HeaderFour />
            <BreadCrumbOne title="Política de Privacidad" page="Política de Privacidad" />
            <div className="section-padding privacy-policy-area">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="privacy-policy-content">
                                <div className="section-title">
                                    <h5 className="title">Última actualización: 22 de agosto de 2025</h5>
                                </div>
                                <h1>Política de Privacidad</h1>
                                <p>
                                    Esta Política de Privacidad describe cómo recopilamos, usamos, almacenamos y protegemos su información personal de acuerdo con las leyes de privacidad aplicables, incluyendo el Reglamento General de Protección de Datos (GDPR) de la Unión Europea, la Ley de Privacidad del Consumidor de California (CCPA), las políticas de Google y otras normativas internacionales.
                                </p>
                                <h4>1. Información que Recopilamos</h4>
                                <ul>
                                    <li><b>Información proporcionada por el usuario:</b> nombre, correo electrónico, dirección, número de teléfono y cualquier otro dato que usted nos proporcione voluntariamente.</li>
                                    <li><b>Datos de uso:</b> información sobre cómo utiliza nuestro sitio web, incluyendo dirección IP, tipo de navegador, páginas visitadas, tiempo de visita y enlaces en los que hace clic.</li>
                                    <li><b>Cookies y tecnologías similares:</b> utilizamos cookies y tecnologías similares para mejorar su experiencia y analizar el tráfico del sitio.</li>
                                </ul>
                                <h4>2. Uso de la Información</h4>
                                <ul>
                                    <li>Proveer, operar y mantener nuestros servicios.</li>
                                    <li>Mejorar, personalizar y expandir nuestros servicios.</li>
                                    <li>Entender y analizar cómo utiliza nuestro sitio web.</li>
                                    <li>Comunicarnos con usted, ya sea directamente o a través de uno de nuestros socios, para brindarle actualizaciones y otra información relacionada con el servicio.</li>
                                    <li>Cumplir con obligaciones legales y regulatorias.</li>
                                </ul>
                                <h4>3. Compartición de la Información</h4>
                                <ul>
                                    <li>No vendemos su información personal a terceros.</li>
                                    <li>Podemos compartir información con proveedores de servicios que nos ayudan a operar el sitio web y prestar nuestros servicios (por ejemplo, alojamiento, análisis, marketing), siempre bajo acuerdos de confidencialidad.</li>
                                    <li>Podemos divulgar información si es requerido por ley, proceso legal o para proteger nuestros derechos.</li>
                                    <li>Si utilizamos servicios de terceros como Google Analytics, estos pueden recopilar información según sus propias políticas de privacidad.</li>
                                </ul>
                                <h4>4. Transferencias Internacionales</h4>
                                <p>
                                    Su información puede ser transferida y procesada en países fuera de su jurisdicción. Nos aseguramos de que dichas transferencias cumplan con las leyes aplicables y que existan salvaguardas adecuadas.
                                </p>
                                <h4>5. Derechos del Usuario</h4>
                                <ul>
                                    <li>Acceder, rectificar o eliminar su información personal.</li>
                                    <li>Oponerse o restringir el procesamiento de sus datos.</li>
                                    <li>Solicitar la portabilidad de sus datos.</li>
                                    <li>Retirar su consentimiento en cualquier momento.</li>
                                    <li>Presentar una reclamación ante una autoridad de control.</li>
                                </ul>
                                <h4>6. Seguridad de la Información</h4>
                                <p>
                                    Implementamos medidas técnicas y organizativas razonables para proteger su información personal contra el acceso no autorizado, alteración, divulgación o destrucción.
                                </p>
                                <h4>7. Retención de Datos</h4>
                                <p>
                                    Conservamos su información personal solo durante el tiempo necesario para cumplir con los fines descritos en esta política y según lo exijan las leyes aplicables.
                                </p>
                                <h4>8. Privacidad de los Menores</h4>
                                <p>
                                    No recopilamos intencionadamente información personal de menores de 16 años. Si usted es padre, madre o tutor y cree que su hijo nos ha proporcionado información personal, contáctenos para eliminarla.
                                </p>
                                <h4>9. Cambios en la Política de Privacidad</h4>
                                <p>
                                    Podemos actualizar esta Política de Privacidad periódicamente. Notificaremos cualquier cambio publicando la nueva política en este sitio web e indicando la fecha de actualización.
                                </p>
                                <h4>10. Contacto</h4>
                                <p>
                                    Si tiene preguntas o desea ejercer sus derechos, puede contactarnos a través del correo electrónico proporcionado en nuestro sitio web.
                                </p>
                                <p style={{ fontSize: "0.9em", color: "#888" }}>
                                    Última actualización: 22 de agosto de 2025
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CtaLayoutOne />
            <FooterOne parentClass="" />
        </main>
    </>
);

export default PrivacyPolicy;